import { useLang } from '@/i18n';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoSection from 'eco-design/base/eco-section';
import EcoImg from 'eco-design/base/eco-img';

export default function H5() {
    const { t } = useLang('theProduct.Animation1');
    const { t: t1 } = useLang('theProduct.Animation1.screen1');
    const { t: t2 } = useLang('theProduct.Animation1.screen2');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const mask1 = document.querySelector('.mask1');
                console.log(mask1);
                const ani = AniContainer.create({
                    triggerElement: `.${styles.comp}`,
                    triggerHook: 0,
                    offset: 0,
                    duration: '530%',
                    asyncTimeLine: [1.6, 5.3],
                    asyncFromTo: [
                        [mask1, { opacity: 0 }, { opacity: 1 }, 1],
                        [mask1, { opacity: 0 }, { opacity: 1 }, 0.1],
                    ],
                });

                return () => {
                    if (ani) AniContainer.removeScene(ani);
                };
            }, 100);
        }
    }, []);
    return (
        <div className={styles.comp} id="wave3-D">
            <div className="screen1 range2">
                <EcoSection
                    label={t1('label')}
                    title={t1('title')}
                    desc={t1.rich('desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    })}
                />
                <div className="screen-b-img">
                    <div className="wd1">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775548/wd1.svg" loading="lazy" alt="" />
                        <div className="text1">{t('wd1')}</div>
                    </div>
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744339902864/D1-1-h5.jpg" />
                </div>
            </div>
            <div className="screen2">
                <div className="mask1"></div>
                <EcoImg className="screen-b-img" pc="https://websiteoss.ecoflow.com/upload/image/1745284818007/1-h5.jpg" />
            </div>
            <div className="screen3">
                <EcoSection
                    label={t2('label')}
                    title={t2('title')}
                    desc={t2.rich('desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    })}
                />
                <div className="screen-b-img">
                    <div className="wd2">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775716/wd2.svg" loading="lazy" alt="" />
                        <div className="text2">{t('wd2')}</div>
                    </div>
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744339903308/D2-1-h5.jpg" />
                </div>
            </div>
            <div className="screen4">
                <EcoImg className="screen-b-img" pc="https://websiteoss.ecoflow.com/upload/image/1744881392427/2-h5.jpg" />
            </div>
        </div>
    );
}
